const STORAGE_KEY = 'documentArchive.navigation';
export const DOCUMENTS_PATH = '/arhiva-dokumenata/dokumenti';

interface DocumentNavigation {
  /** Documents of the list page the user came from, in list order */
  ids: string[];
  /** List URL with its filters, to go back to */
  returnTo: string;
}

/** Remembers the list the user opens a document from (prev/next and "back" on the detail page) */
export const rememberDocumentList = (ids: string[], returnTo: string) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ids, returnTo } satisfies DocumentNavigation));
  } catch {
    // Navigation between documents is a convenience; without storage the detail page still works
  }
};

const readNavigation = (): DocumentNavigation | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as DocumentNavigation) : null;
  } catch {
    return null;
  }
};

export const documentPath = (id: string) => `${DOCUMENTS_PATH}/${id}`;

export const useDocumentNavigation = (currentId: string) => {
  const navigation = readNavigation();
  const index = navigation ? navigation.ids.indexOf(currentId) : -1;
  const ids = index >= 0 && navigation ? navigation.ids : [];

  return {
    returnTo: navigation?.returnTo ?? DOCUMENTS_PATH,
    position: index >= 0 ? index + 1 : null,
    total: ids.length,
    previousId: index > 0 ? ids[index - 1] : null,
    nextId: index >= 0 && index < ids.length - 1 ? ids[index + 1] : null,
  };
};
